import React from 'react';
import { useSelector } from 'react-redux';
import { emitEvent, updateParent } from '../../lib/utils/modal';
import useSessionEntity from '../../hooks/useSessionEntity';
import CTAButton from './CTAButton';

export default function ReturnToMerchant({ merchant, redirect }) {
  const session = useSelector((state) => state.sessions.get('session'));
  const user = useSessionEntity('user');
  const cart = useSessionEntity('shopping_cart');

  const onClick = () => {
    if (session && session.mode === 'modal') {
      emitEvent(
        user,
        {
          action: 'completed',
        },
        cart,
      );
    }

    if (redirect) {
      return redirect();
    } else if (session.mode === 'modal') {
      updateParent('cancel', null);
    } else {
      window.location.href = merchant.url;
    }
  };

  return (
    <>
      {merchant && merchant.url && (
        <CTAButton
          onClick={onClick}
          buttonClass="my-4 max-w-[400px] leading-7 w-3/4 mobile:w-2/3 mx-auto md:w-full bg-primary-blue font-avenir-medium mobile:font-avenir-black tracking-wider text-white rounded-full normal-case mobile:uppercase py-2 mobile:py-3 px-6 text-sm md:text-base inline-block hover:bg-navy-blue flex justify-center items-center"
          buttonText={`Return to ${merchant.name}`}
        />
      )}
    </>
  );
}
